module.exports = __webpack_public_path__ + "static/media/help_form_background.78926ba6.jpeg";